import React from 'react';

/**
 * Component to render Observations and Restrictions of selected room.
 */
class ResultCardConditions extends React.Component {
    render(){
        const { data } = this.props;
        return (
                <article
                    dangerouslySetInnerHTML={{
                        __html: data.split('\r\n').join('<br />'),
                    }}
                />
        );
    }

}

export default ResultCardConditions;



// WEBPACK FOOTER //
// ./src/components/Results/ResultCardConditions.js